export enum UpdateOfferDialogMode {
    SAVING = 'Saving',
    ERROR = 'Error',
    // Returned from saveOffer when user tries to update a deal that has been merged into another
    ERROR_409 = 'Error 409',
    SUCCESS = 'Success'
}
